import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

export default class InsiderBenefitsPage extends Component {
  static propTypes = {
    InsiderBenefits: PropTypes.element,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      InsiderBenefits,
    } = this.props;

    return (
      <StandardPage sport="racing" title="Insider Benefits">
        <div className="main-layout-left-column">
          {InsiderBenefits}
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={["horseRacingNextRaceOffAll", "horseRacingMostFollowed"]}/>
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/Insider/containers/InsiderBenefitsPage.js